import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import { rel } from '../../../../../../utils/rel';
import errorBoundary from '@ifeng/errorBoundary';

class CommentUrl extends React.PureComponent {
    static propTypes = {
        docData: PropTypes.object,
    };

    /**
     * 渲染网页布局
     */
    render() {
        const { noAd, title, commentUrl, url, skey } = this.props.docData;
        // console.log(this.props);

        return (
            <li className={styles.message}>
                <a
                    target="_blank"
                    href={`//gentie.ifeng.com/view.html?docName=${title}&docUrl=${commentUrl}&skey=${skey}&pcUrl=${url}${
                        noAd ? '&noAd' : ''
                    }`}
                    rel={rel}
                />
            </li>
        );
    }
}

export default errorBoundary(CommentUrl);
